<script>
/**
 * Capa de “dedo” + simulación táctil dentro del iframe (?frame=1).
 * Chunk async: la tienda pública no lo carga.
 */
export default {
  name: "HomePreviewTouchLayer",
  data() {
    return {
      fingerVisible: false,
      fingerDown: false,
      fingerX: 0,
      fingerY: 0,
    };
  },
  computed: {
    fingerStyle() {
      return {
        transform: `translate3d(${this.fingerX}px, ${this.fingerY}px, 0) translate(-50%, -50%)`,
      };
    },
  },
  mounted() {
    import("../touch-sim")
      .then(({ installMobileTouchSimulation }) => {
        this._touchSimTeardown = installMobileTouchSimulation({
          onFinger: ({ x, y, down, visible }) => {
            this.fingerX = x;
            this.fingerY = y;
            this.fingerDown = !!down;
            this.fingerVisible = !!visible;
          },
        });
      })
      .catch(() => {
        /* ignore */
      });
  },
  beforeDestroy() {
    if (typeof this._touchSimTeardown === "function") {
      this._touchSimTeardown();
      this._touchSimTeardown = null;
    }
    document.body.classList.remove("storefront-touch-sim");
  },
};
</script>

<template>
  <div
    v-show="fingerVisible"
    class="storefront-finger"
    :class="{ 'storefront-finger--down': fingerDown }"
    :style="fingerStyle"
    aria-hidden="true"
  />
</template>

<style lang="scss" scoped>
.storefront-finger {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20000;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(20, 20, 20, 0.88);
  box-shadow:
    0 0 0 2px rgba(255, 255, 255, 0.55),
    0 4px 12px rgba(0, 0, 0, 0.35);
  pointer-events: none;
  will-change: transform;
  transition: transform 0.05s linear, width 0.12s ease, height 0.12s ease;

  &--down {
    width: 34px;
    height: 34px;
    background: rgba(0, 0, 0, 0.95);
  }
}
</style>

<style lang="scss">
/* Preview frame: ocultar cursor nativo; el círculo actúa como dedo */
body.storefront-touch-sim,
body.storefront-touch-sim * {
  cursor: none !important;
}

body.storefront-touch-sim {
  -webkit-user-select: none;
  user-select: none;
}
</style>
